var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8843 6V3H4V17H11.8843V14",
    stroke: "#444444",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.89893,
    y: 9.5,
    width: 8.60381,
    height: 1.2,
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5414 8.11182L16.3141 9.99998L14.5414 11.8881",
    stroke: "#444444",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8c35475da5bef15578bf67f6c326c178.svg";
export { ForwardRef as ReactComponent };